import { apiSlice } from '../../app/api/apiSlice'

export const skugroupApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSKUChildren: builder.query ({
      query: (sku_id) => `v2/skugroup/?parent=${sku_id}&ordering=id`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUGroup"]
    }),
    updateGroupItem: builder.mutation ({
      query: ({skugroup_id, data}) => ({
        url: `v2/skugroup/${skugroup_id}/`,
        method: 'PUT',
        body: data
      })
    }),
    deleteGroupItem: builder.mutation ({
      query: (skugroup_id) => ({
        url: `v2/skugroup/${skugroup_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["SKUGroup"]
    }),
    createGroupItem: builder.mutation ({
      query: (data) => ({
        url: `v2/skugroup/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SKUGroup"]
    }),

  }),
})


export const {
  useGetSKUChildrenQuery,
  useUpdateGroupItemMutation,
  useDeleteGroupItemMutation,
  useCreateGroupItemMutation
} = skugroupApi
